import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const SoFunktioniertEsPage = lazy(() => import('../pages/so-funktioniert-es/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CheckinPage = lazy(() => import('../pages/dashboard/checkin/page'));
const InsightsPage = lazy(() => import('../pages/dashboard/insights/page'));
const InspirationsPage = lazy(() => import('../pages/dashboard/inspirations/page'));
const AnalyticsPage = lazy(() => import('../pages/dashboard/analytics/page'));
const BetaFeedbackPage = lazy(() => import('../pages/dashboard/beta-feedback/page'));
const MeineZielePage = lazy(() => import('../pages/dashboard/meine-ziele/page'));
const GoalsPage = lazy(() => import('../pages/dashboard/goals/page'));
const ZielChatPage = lazy(() => import('../pages/dashboard/ziel-chat/page'));
const FokusPage = lazy(() => import('../pages/dashboard/fokus/page'));
const EinstellungenPage = lazy(() => import('../pages/dashboard/einstellungen/page'));
const JournalPage = lazy(() => import('../pages/dashboard/journal/page'));
const ProgressPage = lazy(() => import('../pages/dashboard/progress/page'));
const OnboardingPage = lazy(() => import('../pages/dashboard/onboarding/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/so-funktioniert-es',
    element: <SoFunktioniertEsPage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard/checkin',
    element: <CheckinPage />,
  },
  {
    path: '/dashboard/fokus',
    element: <FokusPage />,
  },
  {
    path: '/dashboard/meine-ziele',
    element: <MeineZielePage />,
  },
  {
    path: '/dashboard/goals',
    element: <GoalsPage />,
  },
  {
    path: '/dashboard/ziel-chat',
    element: <ZielChatPage />,
  },
  {
    path: '/dashboard/journal',
    element: <JournalPage />,
  },
  {
    path: '/dashboard/insights',
    element: <InsightsPage />,
  },
  {
    path: '/dashboard/analytics',
    element: <AnalyticsPage />,
  },
  {
    path: '/dashboard/progress',
    element: <ProgressPage />,
  },
  {
    path: '/dashboard/inspirations',
    element: <InspirationsPage />,
  },
  {
    path: '/dashboard/einstellungen',
    element: <EinstellungenPage />,
  },
  {
    path: '/dashboard/onboarding',
    element: <OnboardingPage />,
  },
  {
    path: '/dashboard/beta-feedback',
    element: <BetaFeedbackPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
